var isMobileDevice = false;
if(dojo.isIos || dojo.isAndroid){
    isMobileDevice = true;
}

var onError = (noImageList) => {
    var vp = dojo.window.getBox();
    dojo.attr(dojo.byId("loading"), {
        'class': 'changeSlide'
    });
    var errorId = "errorDiv";
    if(noImageList) {
        errorId = "errorDiv2";
    }
    var divError = dojo.create("div", {
        id: errorId,
        style: {'top': '0px',
                'left': '0px',
                'width': vp.w + 'px',
                'height': vp.h + 'px'}
    }, dojo.byId("mainContent"));
};

var imgWin = (img) => {
    var wn = window.open('resources/print.html?' + escape(img),'win','resizable,width=400,height=200,screenX=0,screenY=0,top=0,left=0');
    wn.focus();
    return false;
};

var zSort = (items) => {
    for (var i = items.length; i >= 0; i--) {
        for (var j = 0; j < i - 1 ; j++) {
            if ((items[j].sortIndex > items[j + 1].sortIndex && items[j].sortIndex != 0 && items[j + 1].sortIndex != 0) ||
                    (items[j].sortIndex == 0 && items[j + 1].sortIndex != 0) ||
                    (items[j].sortIndex == items[j + 1].sortIndex && items[j].title > items[j + 1].title)) {
                var temp = items[j];
                items[j] = items[j + 1];
                items[j + 1] = temp;
            }
        }
    }
    return items;
};

var parseURL = () => {
    var url = {
        host: '',
        query: '',
        args: {}
    };

    var isSet = function(obj) {
        if (typeof(obj) !== 'undefined') return true;
        return false;
    };

    var args = window.location.href.replace(/#.*/g, '').split('?');
    var params = isSet(args[1]) ? args[1].split('&') : [];
    url['host'] = args[0];
    url['query'] = isSet(args[1]) ? args[1] : '';

    for(var i=0; i < params.length; i++){
        args = params[i].split('=');
        var key = args[0];
        var val = isSet(args[1]) ? decodeURIComponent(args[1]) : '';

        if(key == '' || val == '') continue;
        if(isSet(url['args'][key])){
            if(typeof url['args'][key] == 'string'){
                url['args'][key] = [url['args'][key], val];
            } else {
                url['args'][key].push(val);
            }
        } else {
            url['args'][key] = val;
        }
    }
    return url;
};

export { imgWin, zSort, parseURL, isMobileDevice, onError};
